<template>
  <div class="home">
    <v-app-bar color="primary" id="appbar" dark :short="true">
      <v-toolbar-title @click="setViewerActive(false)" style="cursor: pointer">
        JT2Go
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- 
      Install button implementation should we decide we want it or iOS starts supporting it
      <v-btn v-if="installButtonVisible" @click="install" small outlined color="white">Install</v-btn> 
      -->
      <img style="height: 56px" src="/img/sie-logo-claim-white-rgb.svg" />
    </v-app-bar>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" xs="12" sm="6" lg="4">
          <v-hover v-slot:default="{ hover }">
            <v-card
              @click="$refs.fileInput.click()"
              class="white--text align-end card-tile"
              height="100px"
              width="100%"
              :elevation="hover ? 12 : 2"
            >
              <v-card-title>{{ $t("LoadFile") }}</v-card-title>
              <input v-show="false" type="file" ref="fileInput" @change="openFile" />
            </v-card>
          </v-hover>
        </v-col>
        <!-- Load from URL is disabled for now -->
        <!-- <v-col cols="12" xs="12" sm="6" lg="4">
          <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  v-on="on"
                  class="white--text align-end card-tile"
                  height="100px"
                  width="100%"
                  :elevation="hover ? 12 : 2"
                >
                  <v-card-title>{{ $t("LoadFromURL") }}</v-card-title>
                </v-card>
              </v-hover>
            </template>
            <v-card>
              <v-card-title class="text-h5">{{ $t("PleaseEnterURL") }}</v-card-title>
              <v-card-text>
                <v-text-field label="URL" required v-model="urlText"></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">{{ $t("Close") }}</v-btn>
                <v-btn color="primary" text @click="openURL(urlText)">{{ $t("Load") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col> -->
      </v-row>
      <span class="text-h6 font-weight-regular" v-if="recentFiles.length > 0">{{ $t("RecentFiles") }}</span>
      <v-row>
        <v-col cols="6" sm="4" lg="3" xl="2" v-for="recentFile in recentFiles" :key="recentFile.fileName">
          <v-hover v-slot:default="{ hover }">
            <v-card @click="openRecentFile(recentFile)" :elevation="hover ? 12 : 2">
              <v-img
                :src="recentFile.thumbnail"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="200px"
              >
                <v-card-title v-text="recentFile.name"></v-card-title>
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <span class="text-h6 font-weight-regular">{{ $t("SampleFiles") }}</span>
      <v-row>
        <v-col cols="6" sm="4" lg="3" xl="2" v-for="sample in samples" :key="sample.title">
          <v-hover v-slot:default="{ hover }">
            <v-card @click="openSample(sample)" :elevation="hover ? 12 : 2">
              <v-img
                :src="sample.src"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="200px"
              >
                <v-card-title v-text="sample.title"></v-card-title>
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Home",
  data: () => ({
    dialog: false,
    installButtonVisible: false,
    installPrompt: null,
    urlText: null,
    samples: [
      {
        title: "CDPlayer",
        desc: "A sample JT model.",
        src: "../samples/thumbnails/CDPlayer.png",
        path: "/samples/CDPlayer_assm_LW.jt"
      },
      {
        title: "Control_Cabinet",
        desc: "A sample JT model.",
        src: "../samples/thumbnails/ControlCabinet.png",
        path: "/samples/Control_Cabinet_assm_LW.jt"
      },
      {
        title: "ElectricRazor",
        desc: "A sample JT model.",
        src: "../samples/thumbnails/ElectricRazor.png",
        path: "/samples/ElectricRazor_assm_LW.jt"
      },
      {
        title: "Floorjack",
        desc: "A sample JT model.",
        src: "../samples/thumbnails/FloorJack.png",
        path: "/samples/floorjack_assm_LW.jt"
      },
      {
        title: "Radial_Engine",
        desc: "A sample JT model.",
        src: "../samples/thumbnails/RadialEngine.png",
        path: "/samples/Radial_Engine_assm_LW.jt"
      }
    ]
  }),
  computed: {
    ...mapState(["recentFiles"]),
    ...mapGetters(["viewerManager", "snapshotManager"])
  },
  created: function() {
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      this.installPrompt = e;
      this.installButtonVisible = true;
    });
  },
  methods: {
    ...mapActions(["loadFile", "saveFile"]),
    install: function() {
      this.installPrompt.prompt();
      this.installPrompt.userChoice.then(choice => {
        if (choice.outcome === "accepted") {
          this.installButtonVisible = false;
        }
      });
    },
    openSample: function(slide) {
      this.$store.commit("setViewerActive", true);
      this.$root.$emit("open-model", slide.path);
    },
    openFile: function(event) {
      this.$store.commit("setViewerActive", true);
      this.$root.$emit("open-model", event.target.files[0], () => {
        this.snapshotManager.enabled = true;
        this.snapshotManager.createSnapshotPNG(
          pngData => {
            this.saveFile({
              name: event.target.files[0].name,
              type: "fileObject",
              data: event.target.files[0],
              thumbnail: pngData
            });
          },
          {
            width: 527,
            height: 348,
            showOriginal: true
          }
        );
      });
    },
    openURL: function(url) {
      if (url !== null) {
        this.dialog = false;
        this.$store.commit("setViewerActive", true);
        this.$root.$emit(
          "open-model",
          url,
          function() {
            this.snapshotManager.enabled = true;
            this.snapshotManager.createSnapshotPNG(
              function(pngData) {
                var index = url.lastIndexOf("/");
                var name = url.slice(index + 1).replace("|", "/");
                this.saveFile({
                  name: name,
                  type: "url",
                  data: url,
                  thumbnail: pngData
                });
              }.bind(this),
              {
                width: 527,
                height: 348,
                showOriginal: true
              }
            );
          }.bind(this)
        );
        this.urlText = null;
      }
    },
    openRecentFile: function(recentFile) {
      if (recentFile.type === "fileObject") {
        this.loadFile(recentFile.name).then(data => {
          this.$store.commit("setViewerActive", true);
          this.$root.$emit("open-model", data);
        });
      } else if (recentFile.type === "url") {
        this.$store.commit("setViewerActive", true);
        this.$root.$emit("open-model", recentFile.data);
      }
    }
  }
};
</script>

<style scoped>
.card-tile {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.5));
  height: 100px;
}
</style>
